import Vue from 'vue'
import VueRouter from 'vue-router'

import Index from '../views/Index.vue'

Vue.use(VueRouter)


const routes = [
    {
        path: `/`,
        name: 'index',
        component: Index
    },
    {
        path: `/medals/`,
        name: 'medals',
        pathToRegexpOptions: { strict: true },
        component: () => import(/* webpackChunkName: "medals" */ '../views/Medals.vue')
    },
    {
        path: `/medals/:slug/`,
        name: 'medal',
        pathToRegexpOptions: { strict: true },
        component: () => import(/* webpackChunkName: "medals" */ '../views/MedalDetail.vue')
    },
    {
        path: `/recipients/`,
        name: 'recipients',
        pathToRegexpOptions: { strict: true },
        component: () => import(/* webpackChunkName: "recipients" */ '../views/Recipients.vue')
    },
    {
        path: `/recipients/:slug/`,
        name: 'recipient',
        pathToRegexpOptions: { strict: true },
        component: () => import(/* webpackChunkName: "recipients" */ '../views/RecipientDetail.vue')
    },
    {
        path: `/themes/`,
        name: 'themes',
        pathToRegexpOptions: { strict: true },
        component: () => import(/* webpackChunkName: "themes" */ '../views/Themes.vue')
    },
    {
        path: `/theme/:slug/`,
        name: 'theme',
        pathToRegexpOptions: { strict: true },
        component: () => import(/* webpackChunkName: "themes" */ '../views/ThemeDetail.vue')
    },
    {
        path: "*",
        component: () => import(/* webpackChunkName: "global" */ '../views/FileNotFound.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior: function(to, from, savedPosition) {
        if (to.hash) {
            return {selector: to.hash}
        } else if (savedPosition) {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                  resolve(savedPosition)
                }, 1000)
              })
        } else {
            return ({x: 0, y: 0});
        }
    },
    routes
})

export default router
